import { useLandingContent } from '../../hooks/i18n/usePageContent.js'
import * as TOKENS from '../chat/design-tokens'

const landingShell = `w-full scroll-mt-24 px-6 py-20 md:px-12 border-t ${TOKENS.BORDER.default} bg-transparent`
const hubShell = `border-t pt-10 ${TOKENS.BORDER.default}`

const stepCard = `
  group relative overflow-hidden flex flex-col gap-4 p-6 border rounded-none
  ${TOKENS.SURFACE_ROLES.raised} ${TOKENS.BORDER.default}
  transition-colors duration-150
  hover:border-foreground/20 hover:bg-muted
`

interface WorkshopPrepSectionProps {
  surface: 'landing' | 'hub'
}

export function WorkshopPrepSection({ surface }: WorkshopPrepSectionProps) {
  const { workshopPrep } = useLandingContent()
  const shell = surface === 'landing' ? landingShell : hubShell
  const leadClass =
    surface === 'landing'
      ? `max-w-3xl text-lg font-light leading-relaxed ${TOKENS.TEXT.secondary}`
      : `max-w-2xl text-base font-light leading-relaxed ${TOKENS.TEXT.secondary}`
  const frame =
    surface === 'landing'
      ? 'relative z-10 mx-auto flex max-w-6xl flex-col gap-10'
      : 'flex flex-col gap-6'

  return (
    <section id="workshop-prep" aria-labelledby="workshop-prep-heading" className={shell}>
      <div className={frame}>
        <h2 id="workshop-prep-heading" className={leadClass}>
          {workshopPrep.lead}
        </h2>
        <ol className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {workshopPrep.steps.map((step, index) => (
            <li key={step} className={stepCard}>
              <span className={TOKENS.INTERACTION.shimmer} />
              <span
                className={`${TOKENS.TEXT_SIZE.xs} font-mono uppercase tracking-widest ${TOKENS.TEXT.muted}`}
              >
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className={`text-lg font-bold tracking-tight ${TOKENS.TEXT.primary}`}>{step}</h3>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
